// 메뉴 상태 유형
export function menuStatusFormat(number) {
  const list = ["판매", "판매 중지", "품절"];
  let result = "";

  if(number) {
    result = list[number - 1]
  }

  return result;
}

export function payTypeFormat(number) {
  const list = ["만나서 현금", "만나서 카드", "만나서 제로페이", "만나서 온누리상품권", "만나서 동백전", "카드 선결제", "제로페이 선결제", "온누리상품권 선결제", "동백전 선결제"];
  let result = "";

  if(number) {
    result = list[number - 1]
  }

  return result;
}

// 연락처 변경
export function telFormat(text) {
  let result = "";

  if(text) {
    result = text.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, '$1-$2-$3');
  }

  return result;
}
export function formatSecurityTel(value) {
  let telFormat = "";

  if(value) {
    telFormat = value.replace(/^(\d{4})(\d{4})(\d{4})$/, '$1-$2-$3');
  }

  return telFormat;
}

// 사업자번호
export function brNumberFormat(text) {
  let result = "";
  if(text) {
    result =  String(text).toString().replace(/^(\d{3})(\d{2})(\d{5})$/, '$1-$2-$3');
  }

  return result;
}

// 법인번호
export function crNumberFormat(text) {
  let result = "";
  if(text) {
    result =  String(text).toString().replace(/^(\d{6})(\d{7})$/, '$1-$2');
  }

  return result;
}


// 상점 상태 변경
export function formatStatus(status) {
  const statusList = ["승인대기", "승인보류", "사용가능", "사용불가", "일시중지", "영업 중", "영업중지", "노출정지", "", "", "휴식", "영업 준비"];
  let formatStatus = "";

  if(status) {
    formatStatus = statusList[status - 1];
  }

  return formatStatus;
}

// 배달 유형 변경
export function deliveryFormat(value) {
  const list = ["바로배달", "방문포장", "묶음배송", "택배배송", "예약"];
  let result = "";

  if(value) {
    result = list[value - 1];
  }

  return result;
}

// 주문 상태 변경
export function orderTypeFormat(value) {
  const list = ["진행", "진행", "진행", "완료", "완료", "완료", "취소"];
  let result = "";

  if(value) {
    result = list[value - 1];
  }

  return result;
}

// 금액 변경
export function costFormat(value) {
  let result = 0;
  if(value) {
    result =  String(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  return result;
}

// 서비스 변경
export function serviceFormat(value) {
  const list = ["음식배달", "", "", "", "", "택배배송"];
  let result = "";

  if(value) {
    result = list[value - 1];
  }

  return result;
}